import type { SiteConfig } from '../../@types/context/site-config.types';

type Products =
  | 'unsecured-loan'
  | 'unsecured-loan-preform'
  | 'secured-loan'
  | 'secured-loan-book-call'
  | 'secured-loan-preflight'
  | 'secured-loan-apply-smart'
  | 'secured-loan-my-page'
  | 'insurance'
  | 'one-form-preflight'
  | 'one-form'
  | 'one-form-recommendations'
  | 'my-page'
  | 'my-page-overview'
  | 'my-page-loans'
  | 'my-page-credit-cards'
  | 'my-page-secured-loans'
  | 'my-page-insurance'
  | 'credit-card';

export const getProductSiteMap = (path: SiteConfig['path']) => {
  const productPaths: Record<Products, string | undefined> = {
    'unsecured-loan': path.loansApply,
    'unsecured-loan-preform': path.loansPreForm ?? path.loansApply,
    'my-page': path.mypage,
    'secured-loan': path.securedLoansApply,
    'secured-loan-book-call': path.securedLoansBookCall,
    'secured-loan-preflight': path.securedLoansPreflight,
    'secured-loan-apply-smart': path.securedLoansApplySmart,
    'secured-loan-my-page': path.securedLoansMypage,
    insurance: path.insurance,
    'one-form-preflight': path.oneFormPreflight,
    'one-form': path.oneFormApply,
    'one-form-recommendations': path.oneFormRecommendations,
    'my-page-overview': path.mypageOverview,
    'my-page-loans': path.mypageLoans ?? path.mypageOverview,
    'my-page-credit-cards': path.mypageCreditCards ?? path.mypageOverview,
    'my-page-secured-loans': path.mypageSecuredLoans ?? path.mypageOverview,
    'my-page-insurance': path.mypageInsurance ?? path.mypageOverview,
    'credit-card': path.creditCard,
  };

  return productPaths;
};
